import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOcapstoPsicossocial = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="CENTRO DE ATENÇÃO PSICOSSOCIAL" />
                    <CheckContainer>
                        <CheckBox texto="Caps I" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Caps II" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Caps i" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Caps AD" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="24 Horas" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Diário" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="3 Turnos até as 21 Horas" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        {/* <CheckBox texto="Responsável pelo Serviço" grupo="topsicossocial" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" /> */}
                    </CheckContainer>
                </Caixa>
            )
        }
        return partes
    }
}

export default TOcapstoPsicossocial